import { render, staticRenderFns } from "./callTable.vue?vue&type=template&id=a815fe92&scoped=true&"
import script from "./callTable.vue?vue&type=script&lang=js&"
export * from "./callTable.vue?vue&type=script&lang=js&"
import style0 from "./callTable.vue?vue&type=style&index=0&id=a815fe92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a815fe92",
  null
  
)

export default component.exports